import styled from 'styled-components';
import { media } from '../../utils/media';

export const Separator = styled.div`
  height: 0px;
  width: 100%;
  opacity: 0.2;
  border: 0.5px solid ${(props) => props.transparent ? 'transparent' : 'var(--color9)'};
  ${media.phone`border: 1px solid var(--color9)`};
`;